<template>
    <div class="card mt-3">
        <div class="row justify-content-end">
            <div class="d-flex position-absolute mt-3 pt-1 justify-content-end gap-4" :class="[moveLimitButton ? 'extra-margin-end' : 'me-3']">
                <div class="limit-col input-group input-group-sm">
                    <label class="input-group-text">Limit</label>
                    <input type="number" class="form-control" aria-label="limit"
                        v-model="limit">
                    <button :disabled="!adminChats" class="btn btn-outline-secondary" type="button"
                        @click="fetchChatHistory(true)"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <Datatable tableId="mmdConvHistory" uniqueField="resourceId" :columns="columns" :data="adminChats" :compact="true" 
            :orderColumn="orderColumn" :showLoading="loading" :selectCheckboxes="true" @deleteRows="deleteChatHistory"
            :deletable="true" :ignoreCache="true" :detailColumn="{
                baseUrl: 'all-invocations/',
                identifier: 'resourceId',
                name: 'Map My Data Specific Invocation',
            }" @selectedRowCount="updateLimitButtonPlacement"/>
    </div>
</template>
<script>
import Datatable from "../../components/Datatable.vue";
import { DateTimeFormat } from '../../utils/commonFunction'
import { mapActions, mapState } from 'vuex'
export default {
    name: "All Map My Data Invocations",
    components: { Datatable },
    data() {
        return {
            columns: [
                { data: "resourceId", title: "id" },
                { data: "title", title: "title" },
                { data: "userId", title: "user" },
                { 
                    data: "createdAt",
                    title: "timestamp",
                    render: function (data, type, row) {
                        if (!data) return "";
                        try {
                            const parts = data.split('#');
                            if (parts.length > 1) {
                                const timestamp = parts[1];
                                // Return raw timestamp for sorting, formatted date for display
                                if (type === 'sort' || type === 'type') {
                                    return timestamp; // Return timestamp for proper sorting
                                }
                                return DateTimeFormat(timestamp); // Return formatted date for display
                            }
                            return data; // Fallback if format is unexpected
                        } catch (error) {
                            console.error("Error formatting timestamp:", error);
                            return data; // Return original if formatting fails
                        }
                    }
                },
            ],
            orderColumn: [5, "desc"],
            loading: false,
            limit: null,
            moveLimitButton: false,
        };
    },
    computed: {
        ...mapState({
            adminChatLimit: state => state.amdp.mmdAdminChatLimit,
            adminChats: state => state.amdp.mmdAdminChats,
        }),
    },
    watch: {
        limit(newLimit) {
            this.$store.dispatch("amdp/setMMDAdminChatLimit", newLimit);
        },
    },
    methods: {
        ...mapActions({
            showModal: "showModal",
            getChats: "amdp/getChats",
        }), 
        deleteChatHistory(rows) {
            let data = {
                feature: "map_my_data",
                chats: rows,
                screensize: 'xl'
            }
            this.showModal({ component: "deleteChatHistory", data: data });
        },
        async fetchChatHistory(forceGet = false) {
            this.loading = true;
            await this.getChats({ feature: "map_my_data", limit: this.limit, adminHistory: true, forceGet: forceGet }).catch((error) => {
                console.error("Error getting admin chat history: ", error);
                let toastoptions = {
                    message: error.response?.data.error ? error.response.data.error : error.message,
                    type: "error",
                };
                this.$store.dispatch('addToast', toastoptions);
            })
            this.loading = false;
        },
        updateLimitButtonPlacement(selectedRowCount) {
            console.log(selectedRowCount)
            this.moveLimitButton = selectedRowCount > 0;
        },
    },
    async beforeMount() {
        this.$emit("setChat", null);
        this.limit = this.adminChatLimit;
        this.fetchChatHistory();
    },
    emits: ["setChat"]
}
</script>
<style scoped>
.limit-col {
    width: 150px;
}
.extra-margin-end {
    margin-right: 90px;
}
</style>